/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AlbumManagementDetailAlbumResponse } from "./AlbumManagementDetailAlbumResponse";

export type AlbumManagementDetailAlbumResponseApiRespoonse = {
  data?: AlbumManagementDetailAlbumResponse;
  status?: AlbumManagementDetailAlbumResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AlbumManagementDetailAlbumResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
